import SocialGlaasHeader from "./main/SocialGlaasHeader";
import SocialGlassReportContent from "./main/SocialGlassReportContent";

function SocialGlassReport() {
  return (
    <main className="flex h-auto min-h-screen w-screen flex-col overflow-x-hidden">
      {/* Header */}
      <SocialGlaasHeader />

      {/* Main content  */}
      <SocialGlassReportContent />
    </main>
  );
}

export default SocialGlassReport;
